import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-event-details" as const;

export const OpenEventDetailsEventDataSchema = z.object({
  eventId: z.string(),
});

export type OpenEventDetailsEventData = z.infer<
  typeof OpenEventDetailsEventDataSchema
>;

export type OpenEventDetailsEvent = AppEvent<
  typeof eventName,
  OpenEventDetailsEventData
>;

export const isOpenEventDetailsEvent = (
  event: AnyAppEvent
): event is OpenEventDetailsEvent => event.name === eventName;

export { eventName as openEventDetails };
